const incTurn = (turn: number): number => Math.min(turn + 1, 9);

export default incTurn;
